<template>
  <div class="row justify-content-center col-12 mt-2 mb-5">
    <span
      class="col-6 col-lg-4 btn btn-secondary btn-del-subitem"
      @click="removeItem"
      >{{ title }}</span
    >
  </div>
</template>
<script>
export default {
  name: "custom-remove-buttons",
  data: function () {
    return {};
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      default: "Enlever cet item",
    },
    removeAtIndex: {
      type: Number,
      required: true,
    },
  },
  model: {
    prop: "list",
    event: "list:change",
  },
  computed: {
    listLocal: {
      get() {
        return this.list;
      },
      set(value) {
        this.$emit("list:change", value);
      },
    },
  },
  methods: {
    removeItem() {
      this.listLocal.splice(this.removeAtIndex, 1);
      this.$isModified = true;
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// components/Custom/add-remove.vue